export const ppcolors = {
  AppRed: '#c4161c',
  AppRedDarker: '#ae1319',
  AppRedDarkest: '#971115',
  AppYellow: '#ffb81c'
}
